import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Table, Button } from 'reactstrap';
import RawComponent from '../../../Component/Learning/Common/RawHTML';
import "./modal.css"

const ModalDetailTOEFL = ({ modalToeflOpen, setModalToeflOpen, detail }) => {
  const [modalInstructionOpen, setModalInstructionOpen] = useState(false);
  const [selectedInstruction, setSelectedInstruction] = useState('');

  const handleShowInstruction = (instructions) => {
    setSelectedInstruction(instructions);
    setModalInstructionOpen(true);
  };

  const normalizeImageWidths = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    doc.querySelectorAll('img').forEach((img) => {
      const widthAttr = img.getAttribute('width');
      if (widthAttr) {
        const existingStyle = img.getAttribute('style') || '';
        const newStyle = `width: ${widthAttr}px; ${existingStyle}`.trim();
        img.setAttribute('style', newStyle);
        img.removeAttribute('width');
      }
    });

    return doc.body.innerHTML;
  };

  return (
    <>
      <Modal isOpen={modalToeflOpen} toggle={() => setModalToeflOpen(false)} size='lg'>
        <ModalHeader toggle={() => setModalToeflOpen(false)}>
          TOEFL Setup
        </ModalHeader>
        <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div style={{ overflowX: 'auto' }}>
            <Table className="table-bordered table-striped toefl-modal-table" style={{ minWidth: 900 }}>
              <thead>
                <tr>
                  <th>Stage</th>
                  <th>Instruksi</th>
                  <th>Jumlah Soal</th>
                  <th>Durasi (menit)</th>
                  <th>Break (menit)</th>
                </tr>
              </thead>
              <tbody>
                {detail.toefl_setup.map((stage, idx) => (
                  <tr key={idx}>
                    <td>{stage.name}</td>
                    <td className="toefl-instruction">
                      {stage.instructions && stage.instructions !== 'undefined' ? (
                        <Button color="info" size="sm" onClick={() => handleShowInstruction(stage.instructions)}>
                          Lihat Instruksi
                        </Button>
                      ) : (
                        <span className="text-muted">Tidak ada instruksi</span>
                      )}
                    </td>
                    <td>{stage.total_questions}</td>
                    <td>{stage.duration}</td>
                    <td>{stage.break}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalInstructionOpen} toggle={() => setModalInstructionOpen(false)} size='lg'>
        <ModalHeader toggle={() => setModalInstructionOpen(false)}>
          Instruksi TOEFL
        </ModalHeader>
        <ModalBody className="instruction-body" style={{ overflowY: 'auto' }}>
          <RawComponent htmlContent={normalizeImageWidths(selectedInstruction)} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default ModalDetailTOEFL;